import { IAccount, IAccountMappingTemplate, IBalanceSwitchAccount } from '@modeso/types__aumico-lib-annualreport-be';
import { AccountMappingTemplateStatus } from '../enums/account-mapping-template-status.enum';

export interface IAccountMappingDataMapped {
    template: IAccountMappingTemplate;
    status: AccountMappingTemplateStatus.MAPPED;
    accounts: IAccount[];
    balanceSwitchAccounts?: IBalanceSwitchAccount[];
}
